const resolveLender = financeOffersObj => {
  if (financeOffersObj?.lender !== undefined) {
    return financeOffersObj.lender;
  }
  if (financeOffersObj?.offeredBy !== undefined) {
    return financeOffersObj.offeredBy;
  }
  return undefined;
};
const getPaymentErrorState = _ref => {
  let {
    isFinancingUnavailable = false,
    financeOffersObj = {},
    leaseOffersObj = {},
    showNationalAvg = true,
    isFinanceDeal = false,
    isLeaseDeal = false,
    isLoading = false
  } = _ref;
  // Determine lender from financeOffersObj
  const lender = resolveLender(financeOffersObj);
  const isFinanceErrorState = isFinancingUnavailable || !showNationalAvg && (Object.keys(financeOffersObj || {}).length === 0 || financeOffersObj.payment === undefined && !!financeOffersObj?.pricingDetails || lender === undefined || lender === 'National Average Rate');
  const isLeaseErrorState = Object.keys(leaseOffersObj || {}).length === 0 || leaseOffersObj?.payment === undefined && !!leaseOffersObj?.pricingDetails;

  // Only tell the components there is a payment error when it's related to the active tab
  const paymentErrorState = isFinanceDeal && isFinanceErrorState ||
  // Handles finance error state
  isLeaseDeal && isLeaseErrorState && !isLoading; // Handles lease error state

  return {
    paymentErrorState,
    isFinanceErrorState,
    isLeaseErrorState
  };
};
export { getPaymentErrorState as default };
